module.exports = __webpack_public_path__ + "img/a63.a8e62ea6.png";